<template>
  <div v-if="steps && steps.length" class="helpSteps" >

    <div class="helpSteps_header" >
      <div class="helpSteps_header_icon">
        <i class="fa fa-info-circle" ></i>
      </div>
      <h3 class="helpSteps_title" >{{ title }}</h3>
    </div>

    <ol class="helpSteps_steps" >
      <li class="helpSteps_step" v-for="(step, index) in steps" :key="index" >
        <h4 v-if="step.title" >{{ step.title }}</h4>
        <div v-if="step.content" v-html="step.content" class="helpSteps_copy" ></div>
      </li>
    </ol>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'How it Works'
    },
    steps: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped >

@import "src/assets/sass/colours";

.helpSteps_header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.helpSteps_header_icon {
  width: 3rem;
  text-align: center;
  margin-right: 1rem;
  font-size: 1.4rem;
}

.helpSteps_steps {
  list-style: none;
  padding: 0;
  counter-reset: help-steps;
  overflow: hidden;
}

.helpSteps_step {
  position: relative;
  padding: 0.25rem 0 0 4rem;
  counter-increment: help-steps;

  &:not(:first-child) {
    margin-top: 1.5rem;
  }

  &:before {
    display: block;
    content: counter(help-steps);
    background-color: white;
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  &:last-child:after {
    display: block;
    content: '';
    position: absolute;
    height: 9999px;
    width: 0;
    border-left: 1px dashed $grey-medium;
    bottom: 100%;
    left: 1.5rem;
  }
}

.helpSteps_copy {
  color: $grey-medium;
}

</style>
